import React from "react";
import { Text, Tooltip, Flex, Icon } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { BsCoin } from "react-icons/bs";
import { useConfig, type CreditCostKey } from "../context/ConfigContext";

interface CreditCostBadgeProps {
  actionKey: CreditCostKey;
}

/**
 * Displays the credit cost for an action with a coin icon, fetched from getAppConfig (settings/creditCosts).
 * Shows nothing if cost is 0.
 */
export const CreditCostBadge: React.FC<CreditCostBadgeProps> = ({
  actionKey,
}) => {
  const { t } = useTranslation();
  const { getCreditCost } = useConfig();
  const cost = getCreditCost(actionKey);

  if (cost <= 0) return null;

  const tooltipLabel = t("creditCostTooltip", { count: cost });

  return (
    <Tooltip label={tooltipLabel} placement="top" hasArrow>
      <Flex
        as="span"
        display="inline-flex"
        alignItems="center"
        ml={1.5}
        whiteSpace="nowrap"
      >
        <Icon as={BsCoin} boxSize="14px" mr={0.5} aria-hidden />
        <Text as="span" fontSize="sm" fontWeight="semibold">
          {cost}
        </Text>
      </Flex>
    </Tooltip>
  );
};
